import { render, staticRenderFns } from "./ProfileIntegralRules.vue?vue&type=template&id=523dc6f5&scoped=true&"
import script from "./ProfileIntegralRules.vue?vue&type=script&lang=js&"
export * from "./ProfileIntegralRules.vue?vue&type=script&lang=js&"
import style0 from "./ProfileIntegralRules.vue?vue&type=style&index=0&id=523dc6f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523dc6f5",
  null
  
)

export default component.exports